function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-data_svg__a",
  x1: "25.973%",
  x2: "73.226%",
  y1: ".55%",
  y2: "97.802%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5D9CEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E65D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-data_svg__b",
  x1: "36.24%",
  x2: "73.661%",
  y1: "34.736%",
  y2: "76.206%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#FFF3BD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#FFE6A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-data_svg__c",
  x1: "3.349%",
  x2: "100%",
  y1: "3.349%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC6E51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97.766%",
  stopColor: "#DB391F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-data_svg__d",
  x1: "35.379%",
  x2: "75.142%",
  y1: "34.736%",
  y2: "76.206%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#FFF3BD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#FFE6A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-data_svg__e",
  x1: "19.04%",
  x2: "103.238%",
  y1: "34.736%",
  y2: "76.206%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#FFF3BD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#FFE6A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#FFD98A"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 82.003,
  cy: 83.413,
  r: 70.774,
  stroke: "#ABC0D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.571,
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82.003,
  cy: 83.413,
  r: 55.15,
  stroke: "#ABC0D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.571,
  opacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43.277,
  cy: 142.489,
  r: 6.835,
  fill: "#FFF",
  fillRule: "nonzero",
  stroke: "#ABC0D8",
  strokeWidth: 3.571
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.882,
  cy: 127.452,
  r: 4.882,
  stroke: "#155C94",
  strokeWidth: 3.571
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148.597,
  cy: 58.67,
  r: 4.882,
  fill: "#155C94",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDB913",
  fillRule: "nonzero",
  d: "M153.823 6.023l4.35-4.35c.53-.53 1.389-.53 1.919 0l4.35 4.35c.53.53.53 1.389 0 1.919l-4.35 4.35c-.53.53-1.39.53-1.92 0l-4.35-4.35a1.356 1.356 0 010-1.92zM112.402 161.283l2.864-2.864a.874.874 0 011.237 0l2.864 2.864a.876.876 0 010 1.238l-2.863 2.864a.875.875 0 01-1.238 0l-2.864-2.864a.875.875 0 010-1.238zM22.735 34.475l3.63-3.629c.438-.439 1.15-.44 1.59 0l3.63 3.63c.438.438.438 1.151 0 1.59l-3.63 3.63c-.439.438-1.152.438-1.59 0l-3.63-3.63a1.125 1.125 0 010-1.59zM151.962 134.88l3.63-3.63a1.125 1.125 0 011.59.002l3.628 3.629c.44.439.44 1.15.001 1.59l-3.63 3.63a1.126 1.126 0 01-1.59 0l-3.63-3.63a1.125 1.125 0 010-1.59z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(32.315 17.142)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-data_svg__a)",
  d: "M16.78 114.328c0 1.65 1.153 5.205 4.72 5.205 42.337.29 65.533.296 69.586.022 4.468-.302 4.447-4.763 4.468-4.816.23-.566-.755-77.97-1.194-78.395L69.82 10.31c-2.843-3.348-6.402-3.348-8.856-3.348-2.453 0-44.19-.603-44.186 0v107.366z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-data_svg__b)",
  fillRule: "nonzero",
  d: "M26.146 105.322c0 1.314.88 4.148 3.598 4.148 32.274.23 49.956.236 53.046.018 3.406-.241 3.39-3.797 3.406-3.84.175-.45-.576-62.145-.91-62.483L66.58 22.415c-2.168-2.668-4.88-2.668-6.751-2.668-1.87 0-33.686-.48-33.683 0v85.575z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-data_svg__c)",
  d: "M36.454 67.815a1.366 1.366 0 011.802-.114l.13.114 6.72 6.72a1.368 1.368 0 010 1.931 1.367 1.367 0 01-1.803.114l-.129-.114-6.72-6.72a1.366 1.366 0 010-1.931z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-data_svg__c)",
  d: "M43.174 67.815a1.366 1.366 0 012.045 1.802l-.114.129-6.72 6.72a1.365 1.365 0 01-2.044-1.802l.113-.129 6.72-6.72zm26.049 0a1.366 1.366 0 011.802-.114l.129.114 6.72 6.72a1.366 1.366 0 01-1.802 2.045l-.129-.114-6.72-6.72a1.366 1.366 0 010-1.931z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-data_svg__c)",
  d: "M75.943 67.815a1.366 1.366 0 012.045 1.802l-.114.129-6.72 6.72a1.366 1.366 0 01-2.045-1.802l.114-.129 6.72-6.72z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56.727,
  cy: 88.941,
  r: 5.227,
  fill: "url(#empty-data_svg__c)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.154,
  cy: 19.514,
  r: 18.906,
  fill: "url(#empty-data_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-data_svg__d)",
  fillRule: "nonzero",
  d: "M19.303 8.561c3.588 0 5.845 2.098 5.845 5.98 0 2.508-1.162 3.957-3.417 5.206l-.778.407-.706.361-.35.194-.269.167c-.309.207-.427.355-.449.497l-.004.053v3.21a1.366 1.366 0 01-2.722.16l-.009-.16v-3.21c0-1.548.796-2.391 2.473-3.296l1.245-.639c1.65-.866 2.256-1.567 2.256-2.95 0-2.238-.917-3.176-2.926-3.246l-.247-.004a3.22 3.22 0 00-3.334 3.576 1.365 1.365 0 11-2.714.304 5.953 5.953 0 015.791-6.614l.315.004z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18.093,
  cy: 29.385,
  r: 1.673,
  fill: "url(#empty-data_svg__e)",
  fillRule: "nonzero"
})));

function SvgEmptyData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 166
  }, props), _ref, _ref2);
}

export default SvgEmptyData;